<div [id]="selector" class="z-10 hidden bg-white divide-y divide-gray-100 rounded-lg shadow w-44 dark:bg-gray-700">
  <ul class="py-2 text-sm text-gray-700 dark:text-gray-200" aria-labelledby="dropdownDefaultButton">
    <li *ngFor="let item of items">
      <button
        (click)="item.action()"
        class="flex items-center gap-3 text-left w-full px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
      >
        <app-system-icon *ngIf="item.icon" [iconName]="item.icon"></app-system-icon>
        {{ item.label | translate }}
      </button>
    </li>
  </ul>
</div>
